/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react'
import type * as CSS from 'csstype'
import type { UtilityClassNames } from '@s4l/utility-css'

import styles from './styles.module.css'
import Button, { type ButtonSize } from '../../Atoms/Button'

type Animations = 'heartbeat'

export interface ToggleButtonProps {
  iconOnActive: React.ReactElement
  iconOnInactive: React.ReactElement
  onClick?: () => void
  onMouseDown?: (e: React.MouseEvent) => void
  value?: boolean
  animation?: Animations
  activeColor?: CSS.Property.Color
  size?: ButtonSize
  hover?: boolean
  active?: boolean
  focus?: boolean
  disabled?: boolean
  ariaLabel?: string
}

export default function ToggleButton({
  iconOnActive,
  iconOnInactive,
  onClick = () => {},
  onMouseDown,
  value,
  animation,
  activeColor,
  size = 'small',
  hover = false,
  active = false,
  focus = false,
  disabled = false,
  ariaLabel = undefined,
}: ToggleButtonProps) {
  const toggleIcon = value ? iconOnActive : iconOnInactive

  return (
    <div
      className={styles.toggleButtonWrapper}
      aria-pressed={value}
      data-animation={animation}
      style={
        {
          '--active-toggle-button-color': activeColor,
        } as CSS.Properties
      }
    >
      <Button
        className={styles.innerButton as UtilityClassNames}
        variant="icon-rounded"
        size={size}
        leadingIcon={toggleIcon}
        onClick={() => onClick()}
        onMouseDown={onMouseDown}
        role="switch"
        aria-checked={value}
        hover={hover}
        active={active}
        focus={focus}
        disabled={disabled}
        aria-label={ariaLabel}
      />
    </div>
  )
}
